import React, { useContext, useState, useEffect } from "react";
import { API } from "src/shared";
import { apiRequests } from "src/shared/api/api";
import { LoyalitySetting } from "src/enitities";
import { LoyalitySettingContext } from "src/shared";
import { addRow, saveRow, removeRow } from "src/shared";
import { getFilterData } from "../lib/getFilterData";

export default function TableLoyalitySetting() {
  const { token, websocket, data, pathname, params } = useContext(
    LoyalitySettingContext
  );
  const [dataSource, setDataSource] = useState([]);
  useEffect(() => {
    if (data) {
      setDataSource(data);
    }
  }, [data]);
  const [loading, setLoading] = useState(false);
  const handleChanges = async (pagination, filters, sorter, extra) => {
    let newData = dataSource;
    setLoading(true);
    switch (extra.action) {
      case "filter":
        newData = await getFilterData(filters, pathname, params);
        break;
      default:
    }
    setLoading(false);
    setDataSource(newData);
  };

  websocket.onmessage = (message) => {
    const data = JSON.parse(message.data);
    if (data.target === "categories") {
      if (data.action === "create") {
        addRow(dataSource, data.result, setDataSource);
      }
      if (data.action === "edit") {
        saveRow(dataSource, data.result, setDataSource);
      }
      if (data.action === "delete") {
        removeRow(dataSource, data.result.id, setDataSource);
      }
    }
  };
const handleRemove = async (id) => {
  try {
    await apiRequests.loyalitySettings.remove(token, pathname)(id);
    removeRow(dataSource, id, setDataSource);
  } catch (err) {
    console.error("Ошибка при удалении:", err);
  }
};

return (
  <LoyalitySetting
    loading={loading}
    dataSource={dataSource}
    handleSave={API.crud.editTwo(token, pathname)}
    handleRemove={handleRemove}
    handleChanges={handleChanges}
  />
);
}
